export const ADMIN_PAPER_SX = {
  borderRadius: "12px",
  border: "1px solid",
  borderColor: "divider",
  overflow: "hidden",
  boxShadow: "0 4px 14px rgba(15, 23, 42, 0.06)",
  backgroundColor: "background.paper",
};

export const ADMIN_GRID_SX = {
  border: "none",
  fontSize: 13,
  backgroundColor: "background.paper",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "background.subtle",
    borderBottom: "1px solid",
    borderColor: "divider",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 700,
    fontSize: 12,
    color: "text.primary",
  },
  "& .MuiDataGrid-cell": {
    fontSize: 12,
    color: "text.primary",
    borderBottom: "1px solid",
    borderColor: "divider",
    outline: "none",
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "action.hover",
  },
  "& .MuiDataGrid-toolbarContainer": {
    minHeight: 48,
    padding: "8px 12px",
    borderBottom: "1px solid",
    borderColor: "divider",
  },
  "& .MuiDataGrid-footerContainer": {
    minHeight: 44,
    borderTop: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  },
};
